import { ICMSBackgrounds, IShopBackgroundItem, IShopBackgrounds } from 'types';

export const cmsBackgroundsToShopBackgroundsAdapter = (cmsBackgroundsArray: ICMSBackgrounds[]): IShopBackgrounds[] => cmsBackgroundsArray.map(cmsBackgrounds => {
  const shopItems: IShopBackgroundItem[] = cmsBackgrounds.data.map(cmsItem => {
    const { id, url, width, height, license, commercial, is_paid, type, data_url } = cmsItem;

    const shopItem: IShopBackgroundItem = {
      preview_url: url,
      commercial,
      license,
      is_paid,
      height,
      width,
      type,
      url: data_url,
      id,
    };

    return shopItem;
  });

  const shopBackgrounds: IShopBackgrounds = {
    type: cmsBackgrounds.type,
    items: shopItems,
  };

  return shopBackgrounds;
});
